import {useGlobalAlertStore} from '../store/GlobalAlertStore';

export const showError = (title: string, message?: string) =>
  useGlobalAlertStore.getState().show(title, message, 'error');

export const showSuccess = (title: string, message?: string) =>
  useGlobalAlertStore.getState().show(title, message, 'success');

export const showInfo = (title: string, message?: string) =>
  useGlobalAlertStore.getState().show(title, message, 'info');
